import type { SemanticColorToken } from '@vitvio/design-system';
import { CoreBox, CoreIcon } from '@vitvio/design-system';
import { CoreClock } from '@vitvio/time-components';
import { useTimelinePosition } from './hooks/useTimelinePosition';

interface TimeIndicatorLineProps {
  color?: SemanticColorToken;
}

export function TimeIndicatorLine({ color = 'fg.error' }: TimeIndicatorLineProps) {
  const { position, updateInterval } = useTimelinePosition();

  return (
    <CoreBox
      absolute
      flexRow
      alignItems="center"
      top={0}
      left={0}
      transform={`translateY(calc(${position}px - 50%))`}
      transition={`transform ${updateInterval}ms linear`}
      w="full"
    >
      <CoreClock force24h color={color} font="XS_SemiBold" background="bg" ml="1" mr="1" blinkingColon={false} />
      <CoreIcon icon="pointer" size="sm" color={color} />
      <CoreBox bg={color} h="0.5" w="full" borderRadius="full" ml="-2" />
    </CoreBox>
  );
}
